// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("public/img/dragdrop-transparent.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("public/img/magnifier.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --table-content-background: #f5f5f5;
  --device-view-tabs-item-active-color: #6f7e9a;
}

.device-view {
  pointer-events: none;
  flex: 0 0 0;
  margin-top: -58px;
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
}

.device-view .collapsible-bottom-bar__content {
  background: var(--table-content-background);
}

.device-view__header {
  height: 50px;
}

.device-view__header .nav-tabs-custom {
  background: none;
}

.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) {
  height: 45px;
  margin-bottom: 0;
  background: none !important;
}

.device-view__header.scrolling-tabs .sc-wrapper {
  height: 100%;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li {
  margin-right: 5px;
}

.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:last-of-type {
  margin-right: 0;
}

.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:first-of-type {
  margin-left: 10px;
}

.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li a {
  height: 100%;
  margin-right: 0;
}

.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:not(.active) a {
  background: var(--table-content-background);
  width: 100%;
  border-color: #dadada #dadada #ddd !important;
}

.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li.active a {
  background: #fff;
  border-bottom-color: #fff !important;
  border-left: 1px solid #dadada !important;
  border-right: 1px solid #dadada !important;
}

.device-view__header .nav-tabs > li.active > a {
  border-left: 1px solid #dadada;
  border-right: 1px solid #dadada;
}

.nav-tabs-custom .nav-tabs:not(.disable-style) li.device-view__header-close:first-of-type {
  margin-left: 0;
}

.device-view__header-close {
  height: calc(100% + 1px);
  display: flex !important;
}

.device-view__header-close a {
  background: #fff !important;
  border-bottom: 0 !important;
  display: flex !important;
}

.device-view__header-close a:hover {
  background: #f4f4f4 !important;
}

.device-view__header .scroller {
  pointer-events: auto;
  background: #fff;
  border-top: 1px solid #dadada;
  width: 23px;
  height: 100%;
  padding-top: 11px;
}

.device-view__header .scroller-left {
  border-right: 1px solid #dadada;
}

.device-view__header .scroller-right {
  border-left: 1px solid #dadada;
}

.device-view-collapsible-bottom-bar__select-table {
  border-width: var(--base-sizes-1px);
  --tw-border-opacity: 1;
  border-style: solid;
  border-top-width: 0;
  border-bottom-width: 0;
  border-left-width: 0;
  border-color: rgb(232 232 232 / var(--tw-border-opacity));
  height: 40px;
  box-shadow: inset 0 -2px 1px -1px #ddd;
}

.device-view-collapsible-bottom-bar__select-table .scrolling-tabs .sc-wrapper {
  height: 40px;
  padding: 0 !important;
}

.device-view-collapsible-bottom-bar__select-table .scrolling-tabs .scroller, .device-view-collapsible-bottom-bar__select-table .scrolling-tabs .scroller:not(.disabled):hover {
  background: none;
  padding-top: 11px;
  padding-bottom: 8px;
}

.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom {
  background: none;
}

.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) {
  background: none !important;
  border-bottom-color: #0000 !important;
}

.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li {
  height: 40px;
  margin-right: 5px;
}

.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:last-of-type {
  margin-right: 0;
}

.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:hover .device-view-collapsible-bottom-bar__tabs-item-border {
  cursor: default;
}

.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:not(.active):hover .device-view-collapsible-bottom-bar__tabs-item-border {
  cursor: pointer;
  background: #ddd;
}

.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li.active a {
  border-top: 0 !important;
  border-left: 1px solid #fff !important;
  border-right: 1px solid #fff !important;
  padding-top: 11px !important;
}

.device-view-collapsible-bottom-bar__select-table .nav-tabs > li > a:hover {
  background: none !important;
  border-color: #fff !important;
}

.device-view-collapsible-bottom-bar__drag {
  cursor: ns-resize;
  pointer-events: auto;
  z-index: 65100;
  height: 7px;
  position: absolute;
  top: 44px;
  left: 0;
  right: 0;
}

.device-view-collapsible-bottom-bar__drag:after {
  content: "";
  background: none;
  height: 2px;
  margin-top: 4px;
  transition: background .3s;
  display: block;
}

.device-view-collapsible-bottom-bar__drag:hover:after {
  background: var(--info);
}

.device-view-collapsible-bottom-bar__tabs-item-border {
  cursor: pointer;
  height: 4px;
  list-style: 4px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.device-view-collapsible-bottom-bar__tabs-item-border--active {
  background: #6c7e9d;
}

.device-view-setup-tables__overlay-content {
  width: 90vw;
  height: 90vh;
}

.device-view-collapsible-bottom-bar__header-separator {
  background: #ddd;
  width: 1px;
  height: 26px;
  margin-left: 15px;
  margin-right: 10px;
  display: inline-block;
}

.device-view-collapsible-bottom-bar__header-button-config {
  width: 90px;
}

.device-view-setup-tables__selected-tables-wrapper {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 190px 115px;
  min-height: 130px;
}

.device-view-setup-tables__selected-tables-drop {
  pointer-events: auto;
  border: 1px solid #fff;
}

.device-view-setup-tables__selected-tables-drop--hover {
  background-color: #f5f5f580;
  border: 1px dashed #d6d4d5;
}

.device-view-setup-tables__selected-tables-items {
  border: 1px solid #eaeaea;
}

.device-view-setup-tables__selected-tables-item:hover {
  background: #0000000a;
}

.device-view-setup-tables__search {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) 7px 10px no-repeat;
  padding-left: 25px;
}

.device-view-setup-tables__tree-wrapper {
  box-shadow: inset 1px 0 1px -1px #eaeaea;
}

.device-view-setup-tables__tree-list {
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.device-view-setup-tables__tree-item {
  border-radius: 4px;
  padding: 3px 0;
}

.device-view-setup-tables__tree-item:hover {
  background-color: #f5f5f5;
}

.device-view-setup-tables__tree-item-caret {
  vertical-align: baseline;
  width: 21px;
  padding-left: 4px;
  padding-right: 9px;
}

.device-view-setup-tables__tree-item-folder {
  vertical-align: baseline;
  padding-right: 5px;
}

.device-view-setup-tables__footer {
  background: var(--table-content-background);
  border-top: 1px solid #d6d4d5;
}

.device-view-setup-tables__search-results {
  border: 1px solid #eaeaea;
}

.device-view-setup-tables__search-results-item:hover {
  background: #0000000a;
}

.device-view-window {
  box-shadow: var(--window-box-shadow);
  flex-direction: column;
  height: 100%;
  min-height: 300px;
  margin-bottom: 0;
  display: flex;
}

.device-view-window .box-header .box-title {
  margin-right: 20px;
  margin-top: 0 !important;
}

.device-view-window .box-body {
  background: var(--table-content-background);
  cursor: default;
  flex-direction: column;
  flex: 1;
  display: flex;
  overflow-y: auto;
}

.device-view-window .nav-tabs-custom, .device-view-window .table-condensed {
  margin-bottom: 0;
}

.device-view-tabs {
  margin: 0;
  padding: 0;
  list-style: none;
  box-shadow: inset 0 -2px 1px -1px #ddd;
}

.device-view-tabs-item {
  cursor: pointer;
  margin-right: 5px;
  padding: 10px;
  display: inline-block;
  position: relative;
}

.device-view-tabs-item:not(.device-view-tabs-item--active):hover:after {
  content: "";
  background: #ddd;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 4px;
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.device-view-tabs-item--active {
  color: var(--device-view-tabs-item-active-color);
  cursor: default;
}

.device-view-tabs-item--active:after {
  background: var(--device-view-tabs-item-active-color);
  content: "";
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 4px;
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.device-view-hostname-detail tr:hover {
  background: #ecf0f5;
}

.device-view__edge-title-color {
  border-radius: 14px;
  width: 14px;
  height: 14px;
}

@keyframes device-view-packet-detail-blink {
  0% {
    opacity: 0;
  }

  20% {
    opacity: 1;
  }

  80% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    display: none;
  }
}

@keyframes device-view-packet-detail-slide {
  0% {
    height: 0;
  }

  20% {
    height: 10px;
  }

  80% {
    height: 10px;
  }

  100% {
    height: 0;
    display: none;
  }
}

.device-view-packet-detail {
  border-right: 1px solid #d6d6d6;
  min-width: 220px;
  max-width: 440px;
  position: relative;
}

.device-view-packet-detail:after {
  box-shadow: none;
  content: " ";
  pointer-events: none;
  z-index: 1;
  width: 100%;
  height: 100%;
  transition: box-shadow .5s ease-in-out;
  position: absolute;
  top: 0;
}

.device-view-packet-detail--shadow-blink:before {
  content: " ";
  pointer-events: none;
  z-index: 1;
  width: 100%;
  height: 100%;
  animation: 3s ease-in-out forwards device-view-packet-detail-blink;
  position: absolute;
  top: 0;
  box-shadow: 0 0 30px #ccc;
}

.device-view-packet-detail--shadow:after {
  box-shadow: 0 0 30px #ccc;
}

.device-view-packet-detail__close {
  background: none;
  border: 1px solid #d6d6d6;
  border-radius: 3px;
  width: 24px;
  min-width: auto;
  height: 24px;
  padding: 0;
}

.device-view-packet-detail__row:nth-of-type(odd) {
  background: #eeeced;
}

.device-view-packet-detail__color {
  background: #000;
  width: 2px;
}

.device-view-packet-detail__diff {
  border-radius: 8px;
  height: 16px;
  margin-left: -16px;
  line-height: 16px;
}

.device-view-packet-detail__diff-minus {
  color: #de392c;
}

.device-view-packet-detail__diff-plus {
  color: #a8cb60;
}

.device-view-packet-detail__diff--removed {
  background: #ecc4c1;
}

.device-view-packet-detail__diff--added {
  background: #e3efc9;
}

.device-view-packet-detail__highlight-panel {
  background: #6c7e9d;
  height: 0;
  animation: 3s ease-in-out forwards device-view-packet-detail-slide;
}

.device-view-packet-detail__header-type {
  writing-mode: tb-rl;
}

.device-view-packet-detail__traffic-score {
  background: #a8cb60;
  height: 2px;
}

.device-view-packet-detail__traffic-score-progress {
  background: #de392c;
  width: 0;
  height: 2px;
  top: 0;
  left: 0;
}

.device-view-packet-detail__arrow-body {
  background: currentColor;
  width: 1px;
  display: inline-block;
  position: absolute;
  top: 5px;
  bottom: 2px;
  left: 3px;
}

.device-view-packet-detail__arrow-head-down {
  border-top: 4px solid;
  border-left: 4px solid #0000;
  border-right: 4px solid #0000;
  width: 0;
  height: 0;
  position: absolute;
  bottom: 2px;
  left: 0;
}

.device-view-packet-detail__arrow-head-up {
  border-bottom: 4px solid #323232;
  border-left: 4px solid #0000;
  border-right: 4px solid #0000;
  width: 0;
  height: 0;
  position: absolute;
  top: 5px;
  left: 0;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/DeviceView/DeviceView.css","webpack://./services/frontend/app/components/DeviceView/DeviceView.css"],"names":[],"mappings":"AADA;ECEE,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,yDAAyD;EACzD,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yDAA4D;EAC5D,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sEAA8D;EAC9D,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;EAC3C,eAAe;EACf,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;IACT,aAAa;EACf;AACF;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kEAAkE;EAClE,kBAAkB;EAClB,MAAM;EACN,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kEAAkE;AACpE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,MAAM;EACN,OAAO;AACT;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;EAC7B,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,OAAO;AACT","sourcesContent":[":root {\n  --table-content-background: #f5f5f5;\n  --device-view-tabs-item-active-color: #6f7e9a;\n}\n\n.device-view {\n  bottom: 0;\n  flex: 0 0 0;\n  left: 0;\n  margin-top: -58px;\n  pointer-events: none;\n  position: relative;\n  right: 0;\n}\n\n.device-view .collapsible-bottom-bar__content {\n    background: var(--table-content-background);\n  }\n\n.device-view__header {\n  height: 50px;\n}\n\n.device-view__header .nav-tabs-custom {\n    background: none;\n  }\n\n.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) {\n    background: none !important;\n    height: 45px;\n    margin-bottom: 0;\n  }\n\n.device-view__header.scrolling-tabs .sc-wrapper {\n  height: 100%;\n\n    padding-bottom: 0 !important;\n    padding-top: 0 !important;\n}\n\n.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li {\n    margin-right: 5px;\n  }\n\n.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:last-of-type {\n      margin-right: 0;\n    }\n\n.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:first-of-type {\n      margin-left: 10px;\n    }\n\n.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li a {\n  height: 100%;\n\n      margin-right: 0;\n}\n\n.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:not(.active) a {\n      background: var(--table-content-background);\n      border-color: #dadada #dadada #ddd !important;\n      width: 100%;\n    }\n\n.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li.active a {\n      background: #fff;\n      border-left: 1px solid #dadada !important;\n      border-right: 1px solid #dadada !important;\n      border-bottom-color: #fff !important;\n    }\n\n.device-view__header .nav-tabs > li.active > a {\n    border-left: 1px solid #dadada;\n    border-right: 1px solid #dadada;\n  }\n\n.nav-tabs-custom\n  .nav-tabs:not(.disable-style)\n  li.device-view__header-close:first-of-type {\n  margin-left: 0;\n}\n\n.device-view__header-close {\n  /* Override nav > li display attribute to center button content */\n  display: flex !important;\n  height: calc(100% + 1px);\n}\n\n.device-view__header-close a {\n  border-bottom: 0 !important;\n  background: #fff !important;\n  /* Override nav > li > a display attribute to center button content */\n  display: flex !important;\n}\n\n.device-view__header-close a:hover {\n    background: rgb(244, 244, 244) !important;\n  }\n\n.device-view__header .scroller {\n  height: 100%;\n\n  pointer-events: auto;\n  background: #fff;\n  border-top: 1px solid #dadada;\n  padding-top: 11px;\n  width: 23px;\n}\n\n.device-view__header .scroller-left {\n  border-right: 1px solid #dadada;\n}\n\n.device-view__header .scroller-right {\n  border-left: 1px solid #dadada;\n}\n\n.device-view-collapsible-bottom-bar__select-table {\n  border-width: var(--base-sizes-1px);\n  border-left-width: 0;\n  border-top-width: 0;\n  border-bottom-width: 0;\n  border-style: solid;\n  --tw-border-opacity: 1;\n  border-color: rgb(232 232 232 / var(--tw-border-opacity));\n\n  height: 40px;\n  box-shadow: inset 0 -2px 1px -1px #ddd;\n}\n\n.device-view-collapsible-bottom-bar__select-table .scrolling-tabs .sc-wrapper {\n    height: 40px;\n    padding: 0 !important;\n  }\n\n.device-view-collapsible-bottom-bar__select-table .scrolling-tabs .scroller,\n  .device-view-collapsible-bottom-bar__select-table .scrolling-tabs .scroller:not(.disabled):hover {\n    background: none;\n    padding-top: 11px;\n    padding-bottom: 8px;\n  }\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom {\n    background: none;\n  }\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) {\n    background: none !important;\n    border-bottom-color: transparent !important;\n  }\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li {\n    height: 40px;\n    margin-right: 5px;\n  }\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:last-of-type {\n      margin-right: 0;\n    }\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:hover .device-view-collapsible-bottom-bar__tabs-item-border {\n      cursor: default;\n    }\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:not(.active):hover .device-view-collapsible-bottom-bar__tabs-item-border {\n      background: #ddd;\n      cursor: pointer;\n    }\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li.active a {\n    padding-top: 11px !important;\n    border-left: 1px solid #fff !important;\n    border-right: 1px solid #fff !important;\n    border-top: 0 !important;\n  }\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs > li > a:hover {\n    background: none !important;\n    border-color: #fff !important;\n  }\n\n.device-view-collapsible-bottom-bar__drag {\n  cursor: ns-resize;\n  height: 7px;\n  left: 0;\n  pointer-events: auto;\n  position: absolute;\n  right: 0;\n  top: 44px;\n  z-index: 65100;\n}\n\n.device-view-collapsible-bottom-bar__drag:after {\n    display: block;\n    content: '';\n    margin-top: 4px;\n    height: 2px;\n    background: none;\n    transition: background 0.3s ease;\n  }\n\n.device-view-collapsible-bottom-bar__drag:hover:after {\n    background: var(--info);\n  }\n\n.device-view-collapsible-bottom-bar__tabs-item-border {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  bottom: 0;\n  cursor: pointer;\n  height: 4px;\n  left: 0;\n  list-style: 4px;\n  position: absolute;\n  right: 0;\n}\n\n.device-view-collapsible-bottom-bar__tabs-item-border--active {\n  background: #6c7e9d;\n}\n\n.device-view-setup-tables__overlay-content {\n  width: 90vw;\n  height: 90vh;\n}\n\n.device-view-collapsible-bottom-bar__header-separator {\n  display: inline-block;\n  height: 26px;\n  margin-left: 15px;\n  margin-right: 10px;\n  width: 1px;\n  background: #ddd;\n}\n\n.device-view-collapsible-bottom-bar__header-button-config {\n  width: 90px;\n}\n\n.device-view-setup-tables__selected-tables-wrapper {\n  background-image: url('public/img/dragdrop-transparent.png');\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: 190px 115px;\n  min-height: 130px;\n}\n\n.device-view-setup-tables__selected-tables-drop {\n  border: 1px solid #fff;\n  pointer-events: auto;\n}\n\n.device-view-setup-tables__selected-tables-drop--hover {\n  background-color: rgba(245, 245, 245, 0.5);\n  border: 1px dashed #d6d4d5;\n}\n\n.device-view-setup-tables__selected-tables-items {\n  border: 1px solid #eaeaea;\n}\n\n.device-view-setup-tables__selected-tables-item:hover {\n    background: rgba(0, 0, 0, 0.04);\n  }\n\n.device-view-setup-tables__search {\n  background: url('public/img/magnifier.png') 7px 10px no-repeat;\n  padding-left: 25px;\n}\n\n.device-view-setup-tables__tree-wrapper {\n  box-shadow: inset 1px 0 1px -1px #eaeaea;\n}\n\n.device-view-setup-tables__tree-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n\n.device-view-setup-tables__tree-item {\n  border-radius: 4px;\n  padding: 3px 0;\n}\n\n.device-view-setup-tables__tree-item:hover {\n    background-color: #f5f5f5;\n  }\n\n.device-view-setup-tables__tree-item-caret {\n  padding-right: 9px;\n  padding-left: 4px;\n  vertical-align: baseline;\n  width: 21px;\n}\n\n.device-view-setup-tables__tree-item-folder {\n  padding-right: 5px;\n  vertical-align: baseline;\n}\n\n.device-view-setup-tables__footer {\n  background: var(--table-content-background);\n  border-top: 1px solid #d6d4d5;\n}\n\n.device-view-setup-tables__search-results {\n  border: 1px solid #eaeaea;\n}\n\n.device-view-setup-tables__search-results-item:hover {\n    background: rgba(0, 0, 0, 0.04);\n  }\n\n.device-view-window {\n  box-shadow: var(--window-box-shadow);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  margin-bottom: 0;\n  min-height: 300px;\n}\n\n.device-view-window .box-header .box-title {\n      margin-right: 20px;\n      margin-top: 0 !important;\n    }\n\n.device-view-window .box-body {\n    background: var(--table-content-background);\n    cursor: default;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    overflow-y: auto;\n  }\n\n.device-view-window .nav-tabs-custom {\n    margin-bottom: 0;\n  }\n\n.device-view-window .table-condensed {\n    margin-bottom: 0;\n  }\n\n.device-view-tabs {\n  box-shadow: inset 0 -2px 1px -1px #ddd;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.device-view-tabs-item {\n  cursor: pointer;\n  display: inline-block;\n  margin-right: 5px;\n  padding: 10px;\n  position: relative;\n}\n\n.device-view-tabs-item:not(.device-view-tabs-item--active):hover:after {\n    background: #ddd;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    bottom: 0;\n    content: '';\n    display: block;\n    height: 4px;\n    left: 0;\n    position: absolute;\n    right: 0;\n  }\n\n.device-view-tabs-item--active {\n  color: var(--device-view-tabs-item-active-color);\n  cursor: default;\n}\n\n.device-view-tabs-item--active:after {\n    background: var(--device-view-tabs-item-active-color);\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    bottom: 0;\n    content: '';\n    display: block;\n    height: 4px;\n    left: 0;\n    position: absolute;\n    right: 0;\n  }\n\n.device-view-hostname-detail tr:hover {\n  background: #ecf0f5;\n}\n\n.device-view__edge-title-color {\n  border-radius: 14px;\n  height: 14px;\n  width: 14px;\n}\n\n@keyframes device-view-packet-detail-blink {\n  0% {\n    opacity: 0;\n  }\n\n  20% {\n    opacity: 1;\n  }\n\n  80% {\n    opacity: 1;\n  }\n\n  100% {\n    display: none;\n    opacity: 0;\n  }\n}\n\n@keyframes device-view-packet-detail-slide {\n  0% {\n    height: 0;\n  }\n\n  20% {\n    height: 10px;\n  }\n\n  80% {\n    height: 10px;\n  }\n\n  100% {\n    display: none;\n    height: 0;\n  }\n}\n\n.device-view-packet-detail {\n  border-right: 1px solid #d6d6d6;\n  max-width: 440px;\n  min-width: 220px;\n  position: relative;\n}\n\n.device-view-packet-detail:after {\n    box-shadow: none;\n    content: ' ';\n    height: 100%;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    transition: box-shadow 0.5s ease-in-out;\n    width: 100%;\n    z-index: 1;\n  }\n\n.device-view-packet-detail--shadow-blink:before {\n    animation: device-view-packet-detail-blink 3s ease-in-out forwards;\n    box-shadow: 0 0 30px 0 #ccc;\n    content: ' ';\n    height: 100%;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 1;\n  }\n\n.device-view-packet-detail--shadow:after {\n    box-shadow: 0 0 30px 0 #ccc;\n  }\n\n.device-view-packet-detail__close {\n  background: none;\n  border: 1px solid #d6d6d6;\n  border-radius: 3px;\n  height: 24px;\n  padding: 0;\n  min-width: auto;\n  width: 24px;\n}\n\n.device-view-packet-detail__row:nth-of-type(odd) {\n  background: #eeeced;\n}\n\n.device-view-packet-detail__color {\n  background: black;\n  width: 2px;\n}\n\n.device-view-packet-detail__diff {\n  border-radius: 8px;\n  height: 16px;\n  line-height: 16px;\n  margin-left: -16px;\n}\n\n.device-view-packet-detail__diff-minus {\n  color: #de392c;\n}\n\n.device-view-packet-detail__diff-plus {\n  color: #a8cb60;\n}\n\n.device-view-packet-detail__diff--removed {\n  background: #ecc4c1;\n}\n\n.device-view-packet-detail__diff--added {\n  background: #e3efc9;\n}\n\n.device-view-packet-detail__highlight-panel {\n  animation: device-view-packet-detail-slide 3s ease-in-out forwards;\n  background: #6c7e9d;\n  height: 0;\n}\n\n.device-view-packet-detail__header-type {\n  writing-mode: tb-rl;\n}\n\n.device-view-packet-detail__traffic-score {\n  background: #a8cb60;\n  height: 2px;\n}\n\n.device-view-packet-detail__traffic-score-progress {\n  background: #de392c;\n  height: 2px;\n  left: 0;\n  top: 0;\n  width: 0;\n}\n\n.device-view-packet-detail__arrow-body {\n  background: currentColor;\n  bottom: 2px;\n  display: inline-block;\n  left: 3px;\n  position: absolute;\n  top: 5px;\n  width: 1px;\n}\n\n.device-view-packet-detail__arrow-head-down {\n  position: absolute;\n  left: 0;\n  bottom: 2px;\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid currentColor;\n}\n\n.device-view-packet-detail__arrow-head-up {\n  position: absolute;\n  left: 0;\n  top: 5px;\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-bottom: 4px solid #323232;\n}\n",":root {\n  --table-content-background: #f5f5f5;\n  --device-view-tabs-item-active-color: #6f7e9a;\n}\n\n.device-view {\n  pointer-events: none;\n  flex: 0 0 0;\n  margin-top: -58px;\n  position: relative;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.device-view .collapsible-bottom-bar__content {\n  background: var(--table-content-background);\n}\n\n.device-view__header {\n  height: 50px;\n}\n\n.device-view__header .nav-tabs-custom {\n  background: none;\n}\n\n.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) {\n  height: 45px;\n  margin-bottom: 0;\n  background: none !important;\n}\n\n.device-view__header.scrolling-tabs .sc-wrapper {\n  height: 100%;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li {\n  margin-right: 5px;\n}\n\n.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:last-of-type {\n  margin-right: 0;\n}\n\n.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:first-of-type {\n  margin-left: 10px;\n}\n\n.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li a {\n  height: 100%;\n  margin-right: 0;\n}\n\n.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:not(.active) a {\n  background: var(--table-content-background);\n  width: 100%;\n  border-color: #dadada #dadada #ddd !important;\n}\n\n.device-view__header .nav-tabs-custom .nav-tabs:not(.disable-style) li.active a {\n  background: #fff;\n  border-bottom-color: #fff !important;\n  border-left: 1px solid #dadada !important;\n  border-right: 1px solid #dadada !important;\n}\n\n.device-view__header .nav-tabs > li.active > a {\n  border-left: 1px solid #dadada;\n  border-right: 1px solid #dadada;\n}\n\n.nav-tabs-custom .nav-tabs:not(.disable-style) li.device-view__header-close:first-of-type {\n  margin-left: 0;\n}\n\n.device-view__header-close {\n  height: calc(100% + 1px);\n  display: flex !important;\n}\n\n.device-view__header-close a {\n  background: #fff !important;\n  border-bottom: 0 !important;\n  display: flex !important;\n}\n\n.device-view__header-close a:hover {\n  background: #f4f4f4 !important;\n}\n\n.device-view__header .scroller {\n  pointer-events: auto;\n  background: #fff;\n  border-top: 1px solid #dadada;\n  width: 23px;\n  height: 100%;\n  padding-top: 11px;\n}\n\n.device-view__header .scroller-left {\n  border-right: 1px solid #dadada;\n}\n\n.device-view__header .scroller-right {\n  border-left: 1px solid #dadada;\n}\n\n.device-view-collapsible-bottom-bar__select-table {\n  border-width: var(--base-sizes-1px);\n  --tw-border-opacity: 1;\n  border-style: solid;\n  border-top-width: 0;\n  border-bottom-width: 0;\n  border-left-width: 0;\n  border-color: rgb(232 232 232 / var(--tw-border-opacity));\n  height: 40px;\n  box-shadow: inset 0 -2px 1px -1px #ddd;\n}\n\n.device-view-collapsible-bottom-bar__select-table .scrolling-tabs .sc-wrapper {\n  height: 40px;\n  padding: 0 !important;\n}\n\n.device-view-collapsible-bottom-bar__select-table .scrolling-tabs .scroller, .device-view-collapsible-bottom-bar__select-table .scrolling-tabs .scroller:not(.disabled):hover {\n  background: none;\n  padding-top: 11px;\n  padding-bottom: 8px;\n}\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom {\n  background: none;\n}\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) {\n  background: none !important;\n  border-bottom-color: #0000 !important;\n}\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li {\n  height: 40px;\n  margin-right: 5px;\n}\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:last-of-type {\n  margin-right: 0;\n}\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:hover .device-view-collapsible-bottom-bar__tabs-item-border {\n  cursor: default;\n}\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:not(.active):hover .device-view-collapsible-bottom-bar__tabs-item-border {\n  cursor: pointer;\n  background: #ddd;\n}\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li.active a {\n  border-top: 0 !important;\n  border-left: 1px solid #fff !important;\n  border-right: 1px solid #fff !important;\n  padding-top: 11px !important;\n}\n\n.device-view-collapsible-bottom-bar__select-table .nav-tabs > li > a:hover {\n  background: none !important;\n  border-color: #fff !important;\n}\n\n.device-view-collapsible-bottom-bar__drag {\n  cursor: ns-resize;\n  pointer-events: auto;\n  z-index: 65100;\n  height: 7px;\n  position: absolute;\n  top: 44px;\n  left: 0;\n  right: 0;\n}\n\n.device-view-collapsible-bottom-bar__drag:after {\n  content: \"\";\n  background: none;\n  height: 2px;\n  margin-top: 4px;\n  transition: background .3s;\n  display: block;\n}\n\n.device-view-collapsible-bottom-bar__drag:hover:after {\n  background: var(--info);\n}\n\n.device-view-collapsible-bottom-bar__tabs-item-border {\n  cursor: pointer;\n  height: 4px;\n  list-style: 4px;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.device-view-collapsible-bottom-bar__tabs-item-border--active {\n  background: #6c7e9d;\n}\n\n.device-view-setup-tables__overlay-content {\n  width: 90vw;\n  height: 90vh;\n}\n\n.device-view-collapsible-bottom-bar__header-separator {\n  background: #ddd;\n  width: 1px;\n  height: 26px;\n  margin-left: 15px;\n  margin-right: 10px;\n  display: inline-block;\n}\n\n.device-view-collapsible-bottom-bar__header-button-config {\n  width: 90px;\n}\n\n.device-view-setup-tables__selected-tables-wrapper {\n  background-image: url(\"public/img/dragdrop-transparent.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 190px 115px;\n  min-height: 130px;\n}\n\n.device-view-setup-tables__selected-tables-drop {\n  pointer-events: auto;\n  border: 1px solid #fff;\n}\n\n.device-view-setup-tables__selected-tables-drop--hover {\n  background-color: #f5f5f580;\n  border: 1px dashed #d6d4d5;\n}\n\n.device-view-setup-tables__selected-tables-items {\n  border: 1px solid #eaeaea;\n}\n\n.device-view-setup-tables__selected-tables-item:hover {\n  background: #0000000a;\n}\n\n.device-view-setup-tables__search {\n  background: url(\"public/img/magnifier.png\") 7px 10px no-repeat;\n  padding-left: 25px;\n}\n\n.device-view-setup-tables__tree-wrapper {\n  box-shadow: inset 1px 0 1px -1px #eaeaea;\n}\n\n.device-view-setup-tables__tree-list {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.device-view-setup-tables__tree-item {\n  border-radius: 4px;\n  padding: 3px 0;\n}\n\n.device-view-setup-tables__tree-item:hover {\n  background-color: #f5f5f5;\n}\n\n.device-view-setup-tables__tree-item-caret {\n  vertical-align: baseline;\n  width: 21px;\n  padding-left: 4px;\n  padding-right: 9px;\n}\n\n.device-view-setup-tables__tree-item-folder {\n  vertical-align: baseline;\n  padding-right: 5px;\n}\n\n.device-view-setup-tables__footer {\n  background: var(--table-content-background);\n  border-top: 1px solid #d6d4d5;\n}\n\n.device-view-setup-tables__search-results {\n  border: 1px solid #eaeaea;\n}\n\n.device-view-setup-tables__search-results-item:hover {\n  background: #0000000a;\n}\n\n.device-view-window {\n  box-shadow: var(--window-box-shadow);\n  flex-direction: column;\n  height: 100%;\n  min-height: 300px;\n  margin-bottom: 0;\n  display: flex;\n}\n\n.device-view-window .box-header .box-title {\n  margin-right: 20px;\n  margin-top: 0 !important;\n}\n\n.device-view-window .box-body {\n  background: var(--table-content-background);\n  cursor: default;\n  flex-direction: column;\n  flex: 1;\n  display: flex;\n  overflow-y: auto;\n}\n\n.device-view-window .nav-tabs-custom, .device-view-window .table-condensed {\n  margin-bottom: 0;\n}\n\n.device-view-tabs {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  box-shadow: inset 0 -2px 1px -1px #ddd;\n}\n\n.device-view-tabs-item {\n  cursor: pointer;\n  margin-right: 5px;\n  padding: 10px;\n  display: inline-block;\n  position: relative;\n}\n\n.device-view-tabs-item:not(.device-view-tabs-item--active):hover:after {\n  content: \"\";\n  background: #ddd;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  height: 4px;\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.device-view-tabs-item--active {\n  color: var(--device-view-tabs-item-active-color);\n  cursor: default;\n}\n\n.device-view-tabs-item--active:after {\n  background: var(--device-view-tabs-item-active-color);\n  content: \"\";\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  height: 4px;\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.device-view-hostname-detail tr:hover {\n  background: #ecf0f5;\n}\n\n.device-view__edge-title-color {\n  border-radius: 14px;\n  width: 14px;\n  height: 14px;\n}\n\n@keyframes device-view-packet-detail-blink {\n  0% {\n    opacity: 0;\n  }\n\n  20% {\n    opacity: 1;\n  }\n\n  80% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n    display: none;\n  }\n}\n\n@keyframes device-view-packet-detail-slide {\n  0% {\n    height: 0;\n  }\n\n  20% {\n    height: 10px;\n  }\n\n  80% {\n    height: 10px;\n  }\n\n  100% {\n    height: 0;\n    display: none;\n  }\n}\n\n.device-view-packet-detail {\n  border-right: 1px solid #d6d6d6;\n  min-width: 220px;\n  max-width: 440px;\n  position: relative;\n}\n\n.device-view-packet-detail:after {\n  box-shadow: none;\n  content: \" \";\n  pointer-events: none;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  transition: box-shadow .5s ease-in-out;\n  position: absolute;\n  top: 0;\n}\n\n.device-view-packet-detail--shadow-blink:before {\n  content: \" \";\n  pointer-events: none;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  animation: 3s ease-in-out forwards device-view-packet-detail-blink;\n  position: absolute;\n  top: 0;\n  box-shadow: 0 0 30px #ccc;\n}\n\n.device-view-packet-detail--shadow:after {\n  box-shadow: 0 0 30px #ccc;\n}\n\n.device-view-packet-detail__close {\n  background: none;\n  border: 1px solid #d6d6d6;\n  border-radius: 3px;\n  width: 24px;\n  min-width: auto;\n  height: 24px;\n  padding: 0;\n}\n\n.device-view-packet-detail__row:nth-of-type(odd) {\n  background: #eeeced;\n}\n\n.device-view-packet-detail__color {\n  background: #000;\n  width: 2px;\n}\n\n.device-view-packet-detail__diff {\n  border-radius: 8px;\n  height: 16px;\n  margin-left: -16px;\n  line-height: 16px;\n}\n\n.device-view-packet-detail__diff-minus {\n  color: #de392c;\n}\n\n.device-view-packet-detail__diff-plus {\n  color: #a8cb60;\n}\n\n.device-view-packet-detail__diff--removed {\n  background: #ecc4c1;\n}\n\n.device-view-packet-detail__diff--added {\n  background: #e3efc9;\n}\n\n.device-view-packet-detail__highlight-panel {\n  background: #6c7e9d;\n  height: 0;\n  animation: 3s ease-in-out forwards device-view-packet-detail-slide;\n}\n\n.device-view-packet-detail__header-type {\n  writing-mode: tb-rl;\n}\n\n.device-view-packet-detail__traffic-score {\n  background: #a8cb60;\n  height: 2px;\n}\n\n.device-view-packet-detail__traffic-score-progress {\n  background: #de392c;\n  width: 0;\n  height: 2px;\n  top: 0;\n  left: 0;\n}\n\n.device-view-packet-detail__arrow-body {\n  background: currentColor;\n  width: 1px;\n  display: inline-block;\n  position: absolute;\n  top: 5px;\n  bottom: 2px;\n  left: 3px;\n}\n\n.device-view-packet-detail__arrow-head-down {\n  border-top: 4px solid;\n  border-left: 4px solid #0000;\n  border-right: 4px solid #0000;\n  width: 0;\n  height: 0;\n  position: absolute;\n  bottom: 2px;\n  left: 0;\n}\n\n.device-view-packet-detail__arrow-head-up {\n  border-bottom: 4px solid #323232;\n  border-left: 4px solid #0000;\n  border-right: 4px solid #0000;\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: 5px;\n  left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
